<template>
    <BreadCrumb PageTitle="Détail d'un usager" />
    <Detail />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import Detail from "../../components/Usagers/ViewUsager.vue";
    export default defineComponent({
      name: "DetailPage",
      components: {
        BreadCrumb,
        Detail,
      },
    });
  </script>